import { Link } from 'react-router-dom';
import logo from '../assets/logo-versarc.png';
import { Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-gray-100 py-6 px-6 md:px-12">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">

                {/* Brand & Copyright */}
                <div className="flex items-center gap-6">
                    <Link to="/" className="flex items-center">
                        <img src={logo} alt="Versarc" className="h-6 w-auto object-contain" />
                    </Link>
                    <span className="text-xs text-gray-400">© 2026 Sorammi Arc</span>
                </div>

                {/* Minimal Links */}
                <div className="flex items-center gap-6 text-xs uppercase tracking-wider text-gray-500">
                    <Link to="/search" className="hover:text-black transition-colors">Shop</Link>
                    <Link to="/about" className="hover:text-black transition-colors">About</Link>
                    <Link to="/contact" className="hover:text-black transition-colors">Contact</Link>
                    <Link to="/privacy" className="hover:text-black transition-colors">Privacy</Link>
                </div>

                {/* Socials */}
                <div className="flex items-center gap-4">
                    <a href="#" className="text-gray-400 hover:text-black transition-colors"><Facebook size={16} /></a>
                    <a href="#" className="text-gray-400 hover:text-black transition-colors"><Twitter size={16} /></a>
                    <a href="#" className="text-gray-400 hover:text-black transition-colors"><Instagram size={16} /></a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
